import { miniSerializeError, type SerializedError } from "@reduxjs/toolkit"

/** RTK `SerializedError` plus API fields not copied by default `miniSerializeError`. */
export type SerializedErrorWithDetails = SerializedError & { details?: unknown; reason?: string }

/**
 * Drop-in `serializeError` for `createAsyncThunk` so `dispatch(thunk()).error` keeps `details`
 * from axios API errors (same top-level shape as `miniSerializeError`, with `details` appended when present).
 */
export function serializeThunkApiError(value: unknown): SerializedErrorWithDetails {
    const base = miniSerializeError(value)
    if (value !== null && typeof value === "object") {
        const v = value as { details?: unknown; reason?: unknown }
        const extended: SerializedErrorWithDetails = { ...base }
        if (v.details !== undefined) {
            extended.details = v.details
        }
        if (typeof v.reason === "string") {
            extended.reason = v.reason
        }
        if (extended.details !== undefined || extended.reason !== undefined) {
            return extended
        }
    }
    return base as SerializedErrorWithDetails
}
